export enum VerificationRejectReason {
    NoReason = '',
    CustomReason = 'customReason',
    VerificationFailed = 'verificationFailed',
    RequestedDocumentsMissing = 'requestedDocumentsMissing',
    UnreadableBlurryImages = 'unreadableBlurryImages',
    EditedDocumentsPhotos = 'editedDocumentsPhotos',
    NoLatinCharacters = 'noLatinCharacters',
    UserRequest = 'userRequest',
    Underage = 'underage',
}
